(function () {
  'use strict';

  var PENDING_ACTION_KEY = 'tkcPendingPortalAction';

  function extractToken(raw) {
    if (!raw) return '';
    var value = String(raw).trim();
    if (!value) return '';

    try {
      var parsed = JSON.parse(value);
      if (parsed && typeof parsed === 'object') {
        return extractToken(parsed.accessToken || parsed.token || parsed.authToken || parsed.jwt);
      }
    } catch (error) {
      // Stored token is already a plain string.
    }

    return value.replace(/^Bearer\s+/i, '').trim();
  }

  function getToken() {
    var authConfig = (window.TKC && window.TKC.authConfig) || {};
    var keys = Array.isArray(authConfig.tokenFallbackKeys) && authConfig.tokenFallbackKeys.length
      ? authConfig.tokenFallbackKeys
      : [authConfig.tokenKey || 'tkcAccessToken', 'tkcAccessToken', 'tkcAssesstoken', 'accessToken', 'token', 'authToken'];

    for (var i = 0; i < keys.length; i += 1) {
      var token = extractToken(window.localStorage.getItem(keys[i]));
      if (token) return token;
    }

    return '';
  }

  function handleSubmitStoryClick(event) {
    event.preventDefault();

    var authConfig = (window.TKC && window.TKC.authConfig) || {};
    var loginUrl = authConfig.loginUrl || '/pages/login';

    try {
      window.sessionStorage.setItem(
        PENDING_ACTION_KEY,
        JSON.stringify({ action: 'submit-story', ts: Date.now() })
      );
    } catch (error) {
      // Ignore storage errors; My Portal also honors the ?action query param.
    }

    window.location.href = getToken() ? '/pages/my-portal?action=submit-story' : loginUrl;
  }

  function bind(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-hof-submit-story]').forEach(function (element) {
      if (element.dataset.hofSubmitStoryBound === 'true') return;
      element.dataset.hofSubmitStoryBound = 'true';
      element.addEventListener('click', handleSubmitStoryClick);
    });
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  onReady(function () {
    bind(document);
  });

  window.TKC = window.TKC || {};
  window.TKC.bindSubmitStoryCta = bind;
})();
